import { useState, useEffect, useCallback } from 'react';
import styles from './Toast.module.css';

interface ToastState { message: string; visible: boolean; type: 'success' | 'error' | 'info'; }

let showToastFn: (msg: string, type?: 'success' | 'error' | 'info') => void = () => {};

export function toast(message: string, type: 'success' | 'error' | 'info' = 'success') {
  showToastFn(message, type);
}

export function ToastContainer() {
  const [state, setState] = useState<ToastState>({ message: '', visible: false, type: 'success' });

  showToastFn = useCallback((message: string, type: 'success' | 'error' | 'info' = 'success') => {
    setState({ message, visible: true, type });
    setTimeout(() => setState((s) => ({ ...s, visible: false })), 3000);
  }, []);

  if (!state.visible) return null;
  return (
    <div className={`${styles.toast} ${styles[state.type]}`}>
      <span className={styles.icon}>{state.type === 'success' ? '✓' : state.type === 'error' ? '✕' : 'ℹ'}</span>
      {state.message}
    </div>
  );
}
